<template>
  <div class="card width-medium mx-auto">
    <div class="card-body">
      <h2 class="heading-bigger mb-4">{{ $t('messageForm.attachedFiles') }}</h2>

      <f-alert
        v-if="!inquiryID"
        class="my-2"
        theme="warning"
        visible>
        {{ $t('inquiryFiles.youCanAddFileAfterSave') }}
      </f-alert>

      <div
        v-if="files.length"
        class="flex flex-column full-width files-list">
        <div
          v-for="(item, index) of files"
          :key="index"
          :class="{
            'flex flex-column full-width': true,
            'mt-4': index !== 0
          }">
          <label>{{ $t('messageForm.fileName') }}</label>
          <span class="mr-3 mb-2">
            <template v-if="item.preexisting">
              {{ item.file }}
            </template>
            <template v-else>
              {{ item.file.name }}
            </template>
          </span>
          <label>{{ $t('messageForm.descriptionFile') }}</label>
          <template v-if="userType === 'adviser'">
            <f-textarea
              fullWidth
              v-model="item.description"
              :rows="2"/>
          </template>
          <template v-else>
            <p class="my-0">{{ item.description }}</p>
          </template>
          <div class="mt-2 text-right">
            <f-button
              v-if="item.preexisting && userType === 'adviser'"
              theme="primary"
              class="ml-2 mb-1"
              :disabled="actionInProgress"
              @click.prevent="updateFile(index)">
              {{ $t('messageForm.modifyFile') }}
            </f-button>
            <f-button
              v-if="item.preexisting"
              theme="dark"
              class="ml-2 mb-1"
              :disabled="actionInProgress"
              @click.prevent="downloadFile(index)">
              {{ $t('messageForm.downloadFile') }}
            </f-button>
            <f-button
              v-if="!item.preexisting && userType === 'adviser'"
              theme="primary"
              class="ml-2 mb-1"
              :disabled="actionInProgress"
              @click.prevent="saveFile(index)">
              {{ $t('messageForm.uploadFile') }}
            </f-button>
            <f-button
              v-if="userType === 'adviser'"
              class="ml-2 mb-1"
              theme="danger"
              :disabled="actionInProgress"
              @click.prevent="removeFile(index)">
              {{ $t('messageForm.deleteFile') }}
            </f-button>
          </div>
        </div>
      </div>

      <div v-if="!files.length">
        {{ $t('inquiryFiles.noFileForOffer') }}
      </div>


      <f-file-input
        v-if="userType === 'adviser'"
        class="mt-3"
        id="inquiryAttachments"
        label="Dodaj plik"
        icon="attachment"
        accept=".pdf, .jpg, .jpeg, .png, .gif, .doc, .docx, .xls, .xlsx"
        :onChange="attachFiles"/>

    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'inquiry-files',
  props: {
    inquiryID: {
      type: Number,
      default: 0
    },
    inquiryFiles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      files: [],
      userType: null,
      actionInProgress: false
    };
  },
  mounted () {
    this.userType = this.$store.getters['getUserType'].toLowerCase();
    for (let i = 0; i < this.inquiryFiles.length; i++) {
      this.files.push(this.inquiryFiles[i]);
      this.files[i].preexisting = true;
    }
  },
  methods: {
    attachFiles (event) {
      this.files.push({ file: event.target.files[0] });
    },
    removeFile (index) {
      if (!this.files[index].preexisting) {
        this.files.splice(index, 1);

        return;
      }

      this.actionInProgress = true;
      let endpointUrl = '/api/adviser/inquiries/files/delete/' + this.files[index].id;

      FormUtils.submitWithConfirm(this, {
        endpoint: endpointUrl,
        successTitle: this.$t('inquiryFiles.removeFile'),
        successText: this.$t('inquiryFiles.selectedFileRemove'),
        confirmTitle: this.$t('inquiryFiles.areYouSureSelectedFileRemove'),
        confirmText: this.$t('ui.thisOperationCannotUndone'),
        confirmButtonText: this.$t('ui.yesRemove'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('inquiryFiles.removeFileError'),
        successAction: () => {
          this.files.splice(index, 1);
          this.actionInProgress = false;
        },
        cancelAction: () => {
          this.actionInProgress = false;
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      });
    },
    saveFile (index) {
      this.actionInProgress = true;
      let endpointUrl = '/api/adviser/inquiries/files/store';
      let formDataToSend = this.prepareFormDataToSend(index);

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('inquiryFiles.filesAttached'),
        successText: this.$t('inquiryFiles.filesHasBeenAttached'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('inquiryFiles.filesAttachedError'),
        successAction: (response) => {
          this.files.splice(index, 1, response.file);
          Vue.set(this.files[index], 'preexisting', true);
          this.actionInProgress = false;
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      }, ['file']);
    },
    updateFile (index) {
      this.actionInProgress = true;
      let endpointUrl = '/api/adviser/inquiries/files/update/' + this.files[index].id;
      let formDataToSend = { description: this.files[index].description };

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('inquiryFiles.filesUpdated'),
        successText: this.$t('inquiryFiles.filesHasBeenUpdated'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('inquiryFiles.filesUpdatedError'),
        successAction: () => {
          this.actionInProgress = false;
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      });
    },
    downloadFile (index) {
      this.actionInProgress = true;
      let endpointUrl = '/api/' + this.userType + '/inquiries/files/download/' + this.files[index].id;

      this.$http.get(endpointUrl, {
        responseType: 'blob',
      }).then(response => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.files[index].file);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.actionInProgress = false;
        } else {
          Vue.swal({
            title: this.$t('inquiryFiles.downloadFileError'),
            html: this.$t('ui.tryAgain'),
            icon: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
          this.actionInProgress = false;
        }
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('inquiryFiles.downloadFileError'),
          html: this.$t('ui.tryAgain'),
          icon: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.actionInProgress = false;
      });
    },
    prepareFormDataToSend (index) {
      let formDataToSend = {
        inquiry_id: this.inquiryID,
        file: this.files[index].file
      };

      if (this.files[index].description) {
        formDataToSend.description = this.files[index].description;
      }

      return formDataToSend;
    }
  }
}
</script>
